import React from 'react'
import { FieldLabel } from '../form/index'
import CardSearchSelect from './CardSearchSelect'

const CardSearchSelectField = (props) => (
  <FieldLabel {...props} format={null} component={CardSearchSelect} />
)

export default CardSearchSelectField
